import React, { useEffect } from 'react';
import './InspectorPanel.css';
import { RydSelectedNotesInfobox } from '../RydSelectedNotesInfobox';
import {
    useInstrumentWidget,
    useNoteSelectionGroups
} from '../../stores/InspectorPanelStore';
import { RydCollapsableCard } from '../widgets/RydCollapsableCard';

export function InspectorPanel({
    isCollapsed,
    toggleCollapse,
}: {
    isCollapsed: boolean,
    toggleCollapse: () => void,
}) {

    const selectionGroups = useNoteSelectionGroups();
    const instrumentWidget = useInstrumentWidget();

    useEffect(() => {
        if (isCollapsed && instrumentWidget) {
            toggleCollapse();
        }
    }, [instrumentWidget]);

    if (isCollapsed) {
        return (<div id="inspector-panel" className={'collapsed'}>
            <div className="ryd--copyright">rydice 2025</div>
        </div>);
    }

    return (
        <div id="inspector-panel" className={'expanded'}>
            <button onClick={toggleCollapse}
                style={{
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                }}>
                Collapse
            </button>
            <div style={{
                display: 'flex',
                flexDirection: 'row'
            }}>
                {selectionGroups &&
                    <div>
                        <RydSelectedNotesInfobox noteSelectionGroups={selectionGroups} />
                    </div>
                }
                {instrumentWidget &&
                    <RydCollapsableCard title="Instrument" >
                        <div className="inspector-panel-instrument-widget">
                            {instrumentWidget}
                        </div>
                    </RydCollapsableCard>
                }
            </div>

            <div className="ryd--copyright">rydice 2025</div>
        </div>
    );
}